"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Row/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    WSAdapt_template = require("../WSAdapt/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      id: input.id,
      "class": marko_classValue(marko_classValue([
        "row",
        input.class
      ])),
      style: marko_styleValue(input.style)
    }, "0", component, null, 1, {
      onclick: __component.d("click", () => component.emit('click'), false)
    });

  if (input.col) {
    marko_forOf(input.col, function(col, index) {
      WSAdapt_tag(marko_assign({
          class: "col"
        }, col, {
          renderBody: function(out) {
            marko_dynamicTag(out, col.renderBody, null, null, null, null, __component, "row-" + index);
          }
        }), out, __component, index);
    });
  } else {
    marko_dynamicTag(out, input.renderBody, null, null, null, null, __component, "1");
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
